"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showReloadPageDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const confirmdialog_1 = require("primereact/confirmdialog");
const button_1 = require("primereact/button");
function showReloadPageDialog(t, message) {
    return ((0, confirmdialog_1.confirmDialog)({
        message: message,
        header: t('reloadPage_header'),
        icon: 'pi pi-exclamation-triangle',
        className: 'hide-x',
        footer: ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)(button_1.Button, { label: 'Ok', icon: "pi pi-check", className: "p-button-text", onClick: () => { window.location.reload(); } }) }))
    }));
}
exports.showReloadPageDialog = showReloadPageDialog;
